var exports = {
  "r2": "EditGroupModal.module__iconSection___YkgzX2",
  "go": "EditGroupModal.module__iconLabel___YkgzX2",
  "zc": "EditGroupModal.module__iconContainer___YkgzX2",
  "O2": "EditGroupModal.module__iconPreview___YkgzX2",
  "Pz": "EditGroupModal.module__iconPlaceholder___YkgzX2",
  "So": "EditGroupModal.module__iconPlaceholderIcon___YkgzX2",
  "D_": "EditGroupModal.module__iconActions___YkgzX2",
  "Rh": "EditGroupModal.module__iconButtonGroup___YkgzX2",
  "m5": "EditGroupModal.module__iconError___YkgzX2",
};

module.exports = exports;
